import React from 'react';
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image"

type FILE_OPTIONS = 'posBillingAppAdd' | 'posBillingAppList' | 'posBilling' | 'posBillingConfigure' | 'onOrderStatusSave' | 'onOrderStatusAddBlock' | 'onOrderStatusConfigure' | 'orderStatusBilling' | 'onThankYouSave' |  'onThankYouAddBlock' | 'onCheckoutThankYou' | 'onCheckoutSettings' | 'checkoutSettingsIcon' | 'cancelarFacturas' | 'cancelarGlobal' | 'cancelar' | 'clientes' | 'pedimentosNew' | 'pedimentos' | 'productMultipleSAT' | 'productSAT' | 'productIEPS' | 'productTax' | 'orderTax' | 'settupTaxes' | 'billRefundComplete' | 'billRefund' | 'billGlobalConfigure' | 'billGlobalComplete' | 'billGlobalStart' | 'billMultipleComplete' | 'billMultiple' | 'billComplete' | 'billStartPedidos' | 'billStartOrder' | 'onBillsReport' | 'onBills' | 'onCheckout' | 'certificates' | 'clavesPredet' | 'paginaFact' | 'paginaAdd' | 'paginaWrite' | 'paginaHtml' | 'paginaHtmlEdit' | 'paginaHtmlPreview';

export const IMG_Shopify: React.FC<{ file: FILE_OPTIONS }> = ({ file }) => {
  const data = useStaticQuery(graphql`
    query {
      certificates: file(relativePath: { eq: "docimages/shopify_certificates.png" }) {
        childImageSharp {
          fixed (width:900){
            ...GatsbyImageSharpFixed
          }
        }
      }
      clavesPredet: file(relativePath: { eq: "docimages/shopify_clavespredeterminadas.png" }) {
        childImageSharp {
          fixed (width:900){
            ...GatsbyImageSharpFixed
          }
        }
      }
      paginaAdd: file(relativePath: { eq: "docimages/shopify_pages_2025.png" }) {
        childImageSharp {
          fixed (width:900){
            ...GatsbyImageSharpFixed
          }
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      paginaWrite: file(relativePath: { eq: "docimages/shopify_pages_write_2025.png" }) {
        childImageSharp {
          fixed (width:900){
            ...GatsbyImageSharpFixed
          }
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      paginaHtml: file(relativePath: { eq: "docimages/shopify_pages_html_2025.png" }) {
        childImageSharp {
          fixed (width:900){
            ...GatsbyImageSharpFixed
          }
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      paginaHtmlEdit: file(relativePath: { eq: "docimages/shopify_pages_html_edit_2025.png" }) {
        childImageSharp {
          fixed (width:900){
            ...GatsbyImageSharpFixed
          }
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      paginaHtmlPreview: file(relativePath: { eq: "docimages/shopify_pages_html_preview_2025.png" }) {
        childImageSharp {
          fixed (width:900){
            ...GatsbyImageSharpFixed
          }
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      paginaFact: file(relativePath: { eq: "docimages/shopify_paginafact.png" }) {
        childImageSharp {
          fixed (width:900){
            ...GatsbyImageSharpFixed
          }
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      onCheckout: file(relativePath: { eq: "docimages/shopify_thankyou_2025.png" }) {
        childImageSharp {
          fixed (height:550){
            ...GatsbyImageSharpFixed
          }
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      checkoutSettingsIcon: file(relativePath: { eq: "docimages/shopify_settings_checkout_2025.png" }) {
        childImageSharp {
          fixed (width:100){
            ...GatsbyImageSharpFixed
          }
        }
      }
      onCheckoutSettings: file(relativePath: { eq: "docimages/shopify_settings_checkout_step_2025.png" }) {
        childImageSharp {
          fixed (height:550){
            ...GatsbyImageSharpFixed
          }
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      onCheckoutThankYou: file(relativePath: { eq: "docimages/checkout_configure_thankyou_2025.png" }) {
        childImageSharp {
          fixed (height:550){
            ...GatsbyImageSharpFixed
          }
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      onThankYouAddBlock: file(relativePath: { eq: "docimages/checkout_thankyou_add_block_2025.png" }) {
        childImageSharp {
          fixed (height:550){
            ...GatsbyImageSharpFixed
          }
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      onThankYouSave: file(relativePath: { eq: "docimages/checkout_thankyou_save_2025.png" }) {
        childImageSharp {
          fixed (height:550){
            ...GatsbyImageSharpFixed
          }
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      orderStatusBilling: file(relativePath: { eq: "docimages/shopify_order_status_2025.png" }) {
        childImageSharp {
          fixed (height:550){
            ...GatsbyImageSharpFixed
          }
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      onOrderStatusConfigure: file(relativePath: { eq: "docimages/shopify_configure_orderstatus_2025.png" }) {
        childImageSharp {
          fixed (height:550){
            ...GatsbyImageSharpFixed
          }
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      onOrderStatusAddBlock: file(relativePath: { eq: "docimages/shopify_addblock_orderstatus_2025.png" }) {
        childImageSharp {
          fixed (height:550){
            ...GatsbyImageSharpFixed
          }
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      onOrderStatusSave: file(relativePath: { eq: "docimages/shopify_checkout_save_2025.png" }) {
        childImageSharp {
          fixed (height:550){
            ...GatsbyImageSharpFixed
          }
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      posBilling: file(relativePath: { eq: "docimages/shopify_pos_stamp_order_2025.jpg" }) {
        childImageSharp {
          fixed (height:550){
            ...GatsbyImageSharpFixed
          }
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      posBillingConfigure: file(relativePath: { eq: "docimages/shopify_pos_add_2025.png" }) {
        childImageSharp {
          fixed (height:550){
            ...GatsbyImageSharpFixed
          }
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      posBillingAppList: file(relativePath: { eq: "docimages/shopify_pos_apps_select_2025.png" }) {
        childImageSharp {
          fixed (height:550){
            ...GatsbyImageSharpFixed
          }
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      posBillingAppAdd: file(relativePath: { eq: "docimages/shopify_pos_app_add_2025.png" }) {
        childImageSharp {
          fixed (height:550){
            ...GatsbyImageSharpFixed
          }
          fluid(maxWidth: 900) {
            ...GatsbyImageSharpFluid
          }
        }
      }



      onBills: file(relativePath: { eq: "docimages/shopify_bills.png" }) {
        childImageSharp {
          fixed (height:550){
            ...GatsbyImageSharpFixed
          }
        }
      }
      onBillsReport: file(relativePath: { eq: "docimages/shopify_onBillsReport.png" }) {
        childImageSharp {
          fixed (height:550){
            ...GatsbyImageSharpFixed
          }
        }
      }
      billStartOrder: file(relativePath: { eq: "docimages/shopify_billStartOrder.png" }) {
        childImageSharp {
          fixed (width:550){
            ...GatsbyImageSharpFixed
          }
        }
      }
      billStartPedidos: file(relativePath: { eq: "docimages/shopify_billStartPedidos.png" }) {
        childImageSharp {
          fixed (width:550){
            ...GatsbyImageSharpFixed
          }
        }
      }
      billComplete: file(relativePath: { eq: "docimages/shopify_billComplete.png" }) {
        childImageSharp {
          fixed (width:850){
            ...GatsbyImageSharpFixed
          }
        }
      }
      billMultiple: file(relativePath: { eq: "docimages/shopify_multiplebilling.png" }) {
        childImageSharp {
          fixed (width:950){
            ...GatsbyImageSharpFixed
          }
        }
      }
      billMultipleComplete: file(relativePath: { eq: "docimages/shopify_multiBilling.png" }) {
        childImageSharp {
          fixed (width:950){
            ...GatsbyImageSharpFixed
          }
        }
      }
      billGlobalStart: file(relativePath: { eq: "docimages/shopify_globalFirst.png" }) {
        childImageSharp {
          fixed (width:950){
            ...GatsbyImageSharpFixed
          }
        }
      }
      billGlobalComplete: file(relativePath: { eq: "docimages/shopify_billGlobalComplete.png" }) {
        childImageSharp {
          fixed (width:950){
            ...GatsbyImageSharpFixed
          }
        }
      }
      billGlobalConfigure: file(relativePath: { eq: "docimages/shopify_globalconfigure.png" }) {
        childImageSharp {
          fixed (width:950){
            ...GatsbyImageSharpFixed
          }
        }
      }
      billRefund: file(relativePath: { eq: "docimages/shopify_refund.png" }) {
        childImageSharp {
          fixed (width:950){
            ...GatsbyImageSharpFixed
          }
        }
      }
      billRefundComplete: file(relativePath: { eq: "docimages/shopify_refundComplete.png" }) {
        childImageSharp {
          fixed (width:950){
            ...GatsbyImageSharpFixed
          }
        }
      }
      settupTaxes: file(relativePath: { eq: "docimages/shopify_Taxes.png" }) {
        childImageSharp {
          fixed (width:950){
            ...GatsbyImageSharpFixed
          }
        }
      }
      orderTax: file(relativePath: { eq: "docimages/shopify_orderTax.png" }) {
        childImageSharp {
          fixed (width:650){
            ...GatsbyImageSharpFixed
          }
        }
      }
      productTax: file(relativePath: { eq: "docimages/shopify_productTax.png" }) {
        childImageSharp {
          fixed (width:650){
            ...GatsbyImageSharpFixed
          }
        }
      }
      productIEPS: file(relativePath: { eq: "docimages/shopify_IEPS.png" }) {
        childImageSharp {
          fixed (width:950){
            ...GatsbyImageSharpFixed
          }
        }
      }
      productSAT: file(relativePath: { eq: "docimages/shopify_SATEdit.png" }) {
        childImageSharp {
          fixed (width:650){
            ...GatsbyImageSharpFixed
          }
        }
      }
      productMultipleSAT: file(relativePath: { eq: "docimages/shopify_editMany.png" }) {
        childImageSharp {
          fixed (width:950){
            ...GatsbyImageSharpFixed
          }
        }
      }
      pedimentos: file(relativePath: { eq: "docimages/shopify_pedimentos.png" }) {
        childImageSharp {
          fixed (width:950){
            ...GatsbyImageSharpFixed
          }
        }
      }
      pedimentosNew: file(relativePath: { eq: "docimages/shopify_pedimentoNew.png" }) {
        childImageSharp {
          fixed (width:950){
            ...GatsbyImageSharpFixed
          }
        }
      }
      clientes: file(relativePath: { eq: "docimages/shopify_Clientes.png" }) {
        childImageSharp {
          fixed (width:950){
            ...GatsbyImageSharpFixed
          }
        }
      }
      cancelar: file(relativePath: { eq: "docimages/shopify_cancelar.png" }) {
        childImageSharp {
          fixed (width:600){
            ...GatsbyImageSharpFixed
          }
        }
      }
      cancelarGlobal: file(relativePath: { eq: "docimages/shopify_cancelarGlobal.png" }) {
        childImageSharp {
          fixed (width:600){
            ...GatsbyImageSharpFixed
          }
        }
      }
      cancelarFacturas: file(relativePath: { eq: "docimages/shopify_cancelFacturas.png" }) {
        childImageSharp {
          fixed (width:600){
            ...GatsbyImageSharpFixed
          }
        }
      }

    }
  `)

  return (
    data[file].childImageSharp.fluid ?
      <Img
        fluid={data[file].childImageSharp.fluid}
        alt="Shopify image"
        className={`shopify-image-${file}`}
      />
      :
      <Img
        fixed={data[file].childImageSharp.fixed}
        alt="Shopify image"
      />
  )
}
